import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const FILE_UPLOAD_SERVICE = new InjectionToken<FormlibFileUploadService>('File upload service');
export interface FormlibFileUploadService {
  upload: (path: string, body: File | Blob) => Observable<string>;
}
